import * as CryptoJS from 'crypto-js';
const Json2csvParser = require('json2csv').Parser;

var Helper = {
  calculateDiscountOnCoupon,
  roleNameFormatter,
  getCouponConciseConditions,
  dateToTimeStamp,
  TimeStampToDate,
  getAddressString,
  getTimeAndDate,
  toHTMLPicker,
  HTMLTimeToArihantsTime,
  arihantsTimeToString,
  calculateCheckoutDate,
  arihantsTimeToMatInput,
  MatTimeToArihantsTime,
  getMqttPayload,
  findSecsInterval,
  findDaysInterval,
  sorter,
  deepClone,
  getIrPayload,
  getConfigWiFiPass,
  isASCII,
  exportToCSV
}

const MONTHS_SHORT = {
  0: 'JAN',
  1: 'FEB',
  2: 'MAR',
  3: 'APR',
  4: 'MAY',
  5: 'JUN',
  6: 'JUL',
  7: 'AUG',
  8: 'SEP',
  9: 'OCT',
  10: 'NOV',
  11: 'DEC'
};

function getConfigWiFiPass(pass, dev_id) {
  return btoa(pass).split("").reverse().join("");
}

function findDaysInterval(startTime, endTime) {
  let diff, hrs;
  diff = endTime - startTime;
  hrs = diff / (1000 * 3600 * 24);
  return Math.ceil(hrs);
}

function calculateDiscountOnCoupon(benefits, sub_total) {
  let arr = Object.keys(benefits);
  let total_discount = 0;
  for (let i of arr) {
    switch (i) {
      case 'absolute_discount': {
        total_discount += parseInt(benefits[i]);
        break;
      }
      case 'percentage_discount': {
        total_discount += (parseInt(sub_total) * (parseInt(benefits[i]) / 100));
        break;
      }
      default: {
        break;
      }
    }
  }
  return total_discount;
}

function isASCII(str) {
  if (typeof (str) !== 'string') {
    return false;
  }
  for (var i = 0; i < str.length; i++) {
    if (str.charCodeAt(i) > 127 || str.charCodeAt(i) < 32) {
      return false;
    }
  }
  return true;
}

function deepClone(obj) {
  if (obj === null || typeof (obj) !== 'object' || 'isActiveClone' in obj)
    return obj;

  if (obj instanceof Date)
    var temp = new obj.constructor(); //or new Date(obj);
  else
    var temp = obj.constructor();

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      obj['isActiveClone'] = null;
      temp[key] = clone(obj[key]);
      delete obj['isActiveClone'];
    }
  }

  return temp;
}

function sorter(array, key, override_key) {
  var swap = function (array, firstIndex, secondIndex) {
    var temp = array[firstIndex];
    array[firstIndex] = array[secondIndex];
    array[secondIndex] = temp;
  };
  var maxHeap = function (array, i) {
    var l = 2 * i;
    var r = l + 1;
    var largest;
    if (l < array.heapSize && array[l][key] > array[i][key]) {
      largest = l;
    }
    else if (l < array.heapSize && array[l][key] == array[i][key]) {
      if (array[l][override_key] > array[i][override_key]) {
        largest = l
      }
      else {
        largest = i;
      }
    } else {
      largest = i;
    }
    if (r < array.heapSize && array[r][key] > array[largest][key]) {
      largest = r;
    }
    else if (r < array.heapSize && array[r][key] == array[largest][key]) {
      if (array[r][override_key] > array[largest][override_key]) {
        largest = r
      }
    }
    if (largest != i) {
      swap(array, i, largest);
      maxHeap(array, largest);
    }
  };
  var buildHeap = function (array) {
    array.heapSize = array.length;
    for (var i = Math.floor(array.length / 2); i >= 0; i--) {
      maxHeap(array, i);
    }
  };
  buildHeap(array);
  for (var i = array.length - 1; i >= 1; i--) {
    swap(array, 0, i);
    array.heapSize--;
    maxHeap(array, 0);
  }
  return array;
}

function getIrPayload(key, all_codesets, codeset, app_type, device_id, userdevice, _keyHere = null) {
  let keyHere;
  let codeset_obj;
  let len;
  let obj;
  let protocol; let proto_name; let wave_gap;
  for (let i of all_codesets) {
    if (codeset == i._id) {
      codeset_obj = i;
      break;
    }
  }
  keyHere = codeset_obj.keys;
  if (app_type == 'Air Conditioner') {

    len = parseInt(key.first_seq_len) + parseInt(key.sec_seq_len);
    obj = {
      "code": key.code,
      "device": device_id,
      "userdevice": userdevice,
      "freq": codeset_obj.freq,
      "len": len,
      "first_seq_len": key.first_seq_len,
      "sec_seq_len": key.sec_seq_len,
      "rpt_cnt": codeset_obj.rpt_cnt,
      "type": codeset_obj.type
    };
    if (codeset_obj.type == 3) {
      obj.codeset = codeset_obj._id;
      obj.is_ac = true;
      obj.func = key.func;
      obj.power_set = key.power_set;
      obj.temp_set = key.temp_set;
      obj.mode_set = key.mode_set;
      obj.fan_set = key.fan_set;
    }


  }
  else {
    if (codeset_obj.type == 1) {
      let keyHere = _keyHere || codeset_obj.keys;
      console.log('im here at 1');
      len = codeset_obj.len;
      protocol = codeset_obj.protocol;
      proto_name = codeset_obj.proto_name;
      wave_gap = codeset_obj.wave_gap;
      obj = {
        "device": device_id,
        "userdevice": userdevice,
        "code": keyHere[key],
        "len": len,
        "proto_name": proto_name,
        "protocol": protocol,
        "wave_gap": wave_gap
      };
    }
    else if (codeset_obj.type == 2) {
      console.log('im here at 2');
      keyHere = keyHere;
      len = parseInt(keyHere[key].first_seq_len) + parseInt(keyHere[key].sec_seq_len);
      obj = {
        "device": device_id,
        "userdevice": userdevice,
        "freq": codeset_obj.freq,
        "code": keyHere[key].code,
        "len": len,
        "first_seq_len": keyHere[key].first_seq_len,
        "sec_seq_len": keyHere[key].sec_seq_len,
        "rpt_cnt": codeset_obj.rpt_cnt

      };
    }
  }
  return obj || {};
}

function getMqttPayload(message, iv, secretKey) {
  let decoded_msg = null;
  try {
    iv = new Buffer(iv, 'base64').toString('hex');
    iv = CryptoJS.enc.Hex.parse(iv);
    let key = CryptoJS.enc.Hex.parse(secretKey);
    let bytes = CryptoJS.AES.decrypt(message, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.ZeroPadding });
    let plaintext = bytes.toString(CryptoJS.enc.Base64);
    let buf;
    buf = new Buffer(plaintext, 'base64');
    buf = buf.map(char => char < 32 || char == 127 ? 32 : char);
    let buf2 = new Buffer(buf);
    decoded_msg = buf2.toString('ascii');
  } catch (err) {
    console.log(err);
  }
  return decoded_msg;
}

function findSecsInterval(startTime, endTime) {
  let diff, secs;
  diff = endTime - startTime;
  secs = diff / 1000;
  return secs;
}

function roleNameFormatter(role) {
  if (role) {
    return role.replace(/_/g, ' ').replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });
  }
  return '';
}

function calculateCheckoutDate(start, validdays) {
  try {
    if (start && !start.split('T')[1]) {
      start += 'T00:00';
    }
    let _start = new Date(start);
    let _end = new Date(_start);
    _end.setDate(_start.getDate() + validdays);
    return _end;
  }
  catch (err) {
    return "";
  }
}

function getCouponConciseConditions(all_conditions) {
  let concise_cond = [];
  for (let i of all_conditions) {
    if (i.name == "user_specific") {
      if (i.users.length) {
        concise_cond.push({
          name: i.name,
          users: i.users
        });
      }
    }
    else if (i.name == "min_amt" && i.min_amt) {
      concise_cond.push({
        name: i.name,
        amount: i.amount
      });
    }
    else if (i.name == "product_based") {
      if (i.devices.length) {
        concise_cond.push({
          name: i.name,
          devices: i.devices
        })
      }
    }
  }
  return concise_cond;
}

function dateToTimeStamp(inst) {
  const { selectedDay, selectedMonth, selectedYear } = inst;
  let c = new Date();
  c.setDate(selectedDay);
  c.setMonth(selectedMonth);
  c.setYear(selectedYear);
  c.setHours(0, 0, 0, 0);
  return c;
}

function TimeStampToDate(ts) {
  if (ts == -1 || !ts) {
    return '';
  }
  let str = "";
  let c = new Date(ts);
  let month = (parseInt(c.getMonth()) + 1).toString();
  str += (c.getDate() < 10 ? (0 + c.getDate()) : c.getDate()) + '-' + (month < 10 ? (0 + month) : month) + '-' + c.getFullYear();
  return str;
}

function getAddressString(addr) {
  let str = '';
  if (addr != {}) {
    str += addr.address_line_1;
    str += '\n'
    if (addr.address_line_2) {
      str += addr.address_line_2;
      str += '\n'
    }
    str += addr.area;
    str += '\n';
    str += addr.city;
    str += ', ';
    str += addr.state;
    str += '\n';
    str += addr.country;
    str += '\n'
    str += addr.pincode;
  }
  return str;
}

function getTimeAndDate(ts, month_number = 0) {
  let obj;

  if (ts) {
    obj = {
      date: '',
      month: '',
      year: '',
      hour: '',
      min: ''
    };
    ts = new Date(ts);
    if (ts != 'Invalid Date') {
      obj.year = ts.getFullYear();
      obj.date = ts.getDate();
      obj.date = obj.date < 10 ? 0 + obj.date.toString() : obj.date;
      if (month_number) {
        obj.month = ts.getMonth() + 1;
        obj.month = obj.month < 10 ? 0 + obj.month.toString() : obj.month.toString();
      }
      else {
        obj.month = MONTHS_SHORT[ts.getMonth()];
      }
      obj.min = ts.getMinutes();
      obj.min = obj.min < 10 ? 0 + obj.min.toString() : obj.min;
      obj.hour = ts.getHours();
      obj.hour = parseInt(obj.hour) > 12 ? parseInt(obj.hour) - 12 : obj.hour;
      obj.hour = parseInt(obj.hour) < 10 ? 0 + obj.hour.toString() : obj.hour;
      obj.am_pm = parseInt(obj.hour) > 11 ? 'PM' : 'AM'
      obj.hour = parseInt(obj.hour) == 0 ? '12' : obj.hour;

    }

  }
  return obj;
}

function toHTMLPicker(ts = new Date(Date.now())) {

  let obj = this.getTimeAndDate(ts, 1);
  let x = '';
  if (obj) {
    x += obj.year;
    x += '-';
    x += obj.month;
    x += '-';
    x += obj.date;
    x += 'T';
    obj.hour = ts.getHours();
    obj.hour = parseInt(obj.hour) < 10 ? 0 + obj.hour.toString() : obj.hour;
    x += obj.hour;
    x += ':'
    x += obj.min;
    return x;
  }


}

function HTMLTimeToArihantsTime(str) {
  let x;
  if (str) {
    x = parseInt(str.split(':')[0]) * 100 + parseInt(str.split(':')[1])
  }
  return x;
}

function MatTimeToArihantsTime(str) {
  let x;
  x = new Date(str);
  let res = '';
  if (x != 'Invalid Date') {
    res = parseInt(x.getHours()) * 100 + parseInt(x.getMinutes())
  }
  return res;
}

function arihantsTimeToString(time, for_form) {
  let time_str = '';
  let hour;
  hour = Math.floor(time / 100);
  if (for_form) {
    hour = hour < 10 ? '0' + hour.toString() : hour.toString();
    time_str += hour;
    time_str += ':';
    let mins;
    mins = (time - Math.floor(time / 100) * 100);
    mins = mins < 10 ? '0' + mins.toString() : mins.toString();
    time_str += mins;
  }
  else {
    hour = hour > 12 ? hour - 12 : hour;
    time_str += hour.toString();
    time_str += ':';
    let mins;
    mins = (time - Math.floor(time / 100) * 100);
    mins = mins < 10 ? '0' + mins.toString() : mins.toString();
    time_str += mins;
    time_str += ' ';
    time_str += Math.floor(time / 100) >= 12 ? 'PM' : 'AM';
  }
  return time_str;
}

function arihantsTimeToMatInput(time) {

  let hour;
  hour = Math.floor(time / 100);

  let mins;
  mins = (time - Math.floor(time / 100) * 100);

  let res = new Date()
  res.setHours(hour, mins);
  return res;

}

function exportToCSV(data, fields, filename) {
  const json2csvParser = new Json2csvParser({ fields });
  const csv = json2csvParser.parse(data);
  saveTextAsFile(csv, filename);
}

function saveTextAsFile(data, filename) {

  if (!data) {
    return;
  }

  if (!filename) filename = 'console.json'

  var blob = new Blob([data], { type: 'text/plain' }),
    e = document.createEvent('MouseEvents'),
    a = document.createElement('a')

  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(blob, filename);
  }
  else {
    let e, a;
    e = document.createEvent('MouseEvents')
    a = document.createElement('a');

    a.download = filename;
    a.href = window.URL.createObjectURL(blob);
    a.dataset.downloadurl = ['text/plain', a.download, a.href].join(':');
    e.initEvent('click', true, false, window,
      0, 0, 0, 0, 0, false, false, false, false, 0, null);
    a.dispatchEvent(e);
  }
}

export default Helper;


// WEBPACK FOOTER //
// ./services/Helper.js